import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/FFO+.jpeg";
import About from "../components/About";
import Brands from "../components/Brands";
import Faqs from "../components/Faqs";
import WhyChoose from "../components/WhyChoose";
import Services from "../components/Services";

import ServiceShowcase from "../components/ServiceShowcase";

import "./AreaPage.css";

const AREA_SEO_CONTENT = {
  "koramangala": {
    title: "Appliance Repair Services in Koramangala Bangalore",
    description:
      "Quick appliance repair service in Koramangala, Bangalore for all major brands with expert technicians.",
    keywords:
      "appliance repair koramangala, home appliance service koramangala, samsung service in koramangala",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-koramangala",
    robots: "index, follow",
  },
  "hsr-layout": {
    title: "Appliance Repair in HSR Layout Bangalore",
    description:
      "Reliable appliance repair service in HSR Layout, Bangalore with fast doorstep help for all major brands.",
    keywords:
      "appliance repair hsr layout, appliance service hsr layout, washing machine repair hsr layout",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-hsr-layout",
    robots: "index, follow",
  },
  "electronic-city": {
    title: "Appliance Repair in Electronic City Bangalore",
    description:
      "Affordable appliance repair service in Electronic City, Bangalore for washing machines, fridges, and more.",
    keywords:
      "appliance repair electronic city, appliance service electronic city, washing machine repair bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-electronic-city",
    robots: "index, follow",
  },
  "whitefield": {
    title: "Appliance Repair Services in Whitefield Bangalore",
    description:
      "Professional appliance repair service in Whitefield, Bangalore with same-day doorstep support available.",
    keywords:
      "appliance repair whitefield, appliance service whitefield, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-whitefield",
    robots: "index, follow",
  },
  "mahadevapura": {
    title: "Appliance Repair in Mahadevapura Bangalore",
    description:
      "Trusted appliance service in Mahadevapura, Bangalore for all major home appliances and brands.",
    keywords:
      "appliance repair mahadevapura, appliance service mahadevapura, appliance service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-mahadevapura",
    robots: "index, follow",
  },
  "jayanagar": {
    title: "Appliance Repair Services in Jayanagar Bangalore",
    description:
      "Expert appliance repair service in Jayanagar, Bangalore with quick and affordable doorstep solutions.",
    keywords:
      "appliance repair jayanagar, appliance service jayanagar, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-jayanagar",
    robots: "index, follow",
  },
  "rajajinagar": {
    title: "Appliance Repair in Rajajinagar Bangalore",
    description:
      "Reliable appliance repair service in Rajajinagar, Bangalore by experienced technicians for all brands.",
    keywords:
      "appliance repair rajajinagar, appliance service rajajinagar, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-rajajinagar",
    robots: "index, follow",
  },
  "malleswaram": {
    title: "Appliance Repair Services in Malleswaram Bangalore",
    description:
      "Fast appliance repair service in Malleswaram, Bangalore with professional support for all appliances.",
    keywords:
      "appliance repair malleswaram, appliance service malleswaram, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-malleswaram",
    robots: "index, follow",
  },
  "marathahalli": {
    title: "Appliance Repair in Marathahalli Bangalore",
    description:
      "Affordable appliance repair service in Marathahalli, Bangalore with trained service professionals.",
    keywords:
      "appliance repair marathahalli, appliance service marathahalli, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-marathahalli",
    robots: "index, follow",
  },
  "jp-nagar": {
    title: "Appliance Repair Services in JP Nagar Bangalore",
    description:
      "Doorstep appliance repair service in JP Nagar, Bangalore for refrigerators, ACs, washing machines, and more.",
    keywords:
      "appliance repair jp nagar, appliance service jp nagar, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-jp-nagar",
    robots: "index, follow",
  },
  "banashankari": {
    title: "Appliance Repair in Banashankari Bangalore",
    description:
      "Trusted appliance repair service in Banashankari, Bangalore with quick response and expert technicians.",
    keywords:
      "appliance repair banashankari, appliance service banashankari, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-banashankari",
    robots: "index, follow",
  },
  "kr-puram": {
    title: "Appliance Repair Services in KR Puram Bangalore",
    description:
      "Professional appliance service in KR Puram, Bangalore for all leading appliance brands.",
    keywords:
      "appliance repair kr puram, appliance service kr puram, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-kr-puram",
    robots: "index, follow",
  },
  "btm-layout": {
    title: "Appliance Repair Services in BTM Layout Bangalore",
    description:
      "Expert appliance repair service in BTM Layout, Bangalore for washing machines, fridges, and microwaves.",
    keywords:
      "appliance repair btm layout, appliance service btm layout, samsung service bangalore",
    canonical:
      "https://customersupports24x7.in/appliance-repair-service-in-btm-layout",
    robots: "index, follow",
  },
};

const AreaPage = () => {
  // ✅ GET AREA FROM URL
  const { area: areaParam } = useParams();
  const { pathname } = useLocation();

  let area = areaParam;

  if (!area) {
    const hyphenPrefix = "/appliance-repair-service-in-";
    const slashPrefix = "/appliance-repair-service-in-";

    if (pathname.startsWith(hyphenPrefix)) {
      area = pathname.slice(hyphenPrefix.length);
    } else if (pathname.startsWith(slashPrefix)) {
      area = pathname.slice(slashPrefix.length);
    }
  }

  area = (area || "").split("/")[0];

  // ✅ FORMAT NAME (electronic-city → Electronic City)
  const areaName = (area || "")
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

  const seo = AREA_SEO_CONTENT[area] || {
    title: `Appliance Repair Services in ${areaName} Bangalore`,
    description: `Expert appliance repair services in ${areaName}, Bangalore for washing machines, refrigerators, ACs, and other home appliances.`,
    keywords: `appliance repair ${areaName}, appliance service ${areaName}, home appliance repair Bangalore`,
    canonical: `https://customersupports24x7.in/appliance-repair-service-in-${area}`,
    robots: "index, follow",
  };

  // ✅ SCROLL TOP
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [area]);

  return (
    <>
      {/* ✅ SEO */}
      <Helmet>
        <title>{seo.title}</title>

        <meta name="description" content={seo.description} />

        <meta name="keywords" content={seo.keywords} />
        <meta name="robots" content={seo.robots} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:image" content="https://customersupports24x7.in/customerSupport.png" />
        <meta property="og:url" content={seo.canonical} />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />
        <meta name="twitter:image" content="https://customersupports24x7.in/customerSupport.png" />

        <link rel="canonical" href={seo.canonical} />
      </Helmet>

      {/* ✅ PAGE */}
      <main className="area-page">
        <div className="lg-banner-wrapper">
          <InnerBanner
            title={`Appliance Repair Service in ${areaName}`}
            bgImage={serviceBg}
          />
        </div>
        {/* CONTENT */}
        {/* <section className="area-detail">
          <h2>Repair Services in {areaName}</h2>

          <ul>
            <li><FaTools /> Screen repair</li>
            <li><FaShieldAlt /> Warranty</li>
            <li><FaMapMarkerAlt /> Service across {areaName}</li>
          </ul>
        </section> */}

        {/* COMPONENTS */}
        {/* <BrandSlider /> */}
      
        {/* <WhyChoose /> */}
        {/* <Timeline /> */}
        {/* <Reviews /> */}
        <About />
      <Services />
      <Brands />

      <WhyChoose />

      <ServiceShowcase />
  
      <Faqs />
     

      </main>
    </>
  );
};

export default AreaPage;
